import useToggle from "common/hooks/useToggle"
import ContactosService from "common/services/ContactosService"
import { requestHandler } from "common/utils/utils"
import { createContext, useCallback, useContext, useState } from "react"
import { useHistory } from "react-router-dom"

const ContactosContext = createContext({})

const ContactosProvider = ({ children }: $TSMigrationFixMe) => {
  const history = useHistory()
  const [showDeleteContacto, toggleShowDeleteContacto] = useToggle(false)
  const [selectedContacto, setSelectedContacto] = useState(null)
  const [selectedMultipleContactos, setSelectedMultipleContactos] = useState([])
  const [showDeleteMultipleContactos, toggleShowDeleteMultipleContactos] =
    useToggle(false)
  const [fetching, setFetching] = useState(false)
  const [showEditContacto, toggleShowEditContacto] = useToggle(false)

  const handleDeleteContacto = useCallback(
    (contacto: $TSMigrationFixMe) => {
      setSelectedContacto(contacto)
      toggleShowDeleteContacto()
    },
    [setSelectedContacto, toggleShowDeleteContacto]
  )

  const onMultipleDeleteSuccess = () => {
    setFetching(false)
    setSelectedMultipleContactos([])
  }

  const handleDeleteMultipleContactos = async () => {
    setFetching(true)
    // @ts-expect-error TS(2554): Expected 7 arguments, but got 4.
    await requestHandler(
      selectedMultipleContactos,
      ContactosService.deleteManyById,
      onMultipleDeleteSuccess,
      "Los contactos se han eliminado correctamente."
    )
    setFetching(false)
  }

  const handleDeleteContactoHttp = async (url: $TSMigrationFixMe) => {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    await ContactosService.deleteById(selectedContacto?.id)
    setSelectedMultipleContactos((prev) =>
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      prev.filter(({ id }) => id !== selectedContacto?.id)
    )
    setSelectedContacto(null)
    if (url) history.push(url)
  }

  const handleEditContacto = (contacto: $TSMigrationFixMe) => {
    setSelectedContacto(contacto)
    toggleShowEditContacto()
  }

  const value = {
    fetching,
    showDeleteContacto,
    toggleShowDeleteContacto,
    selectedContacto,
    selectedMultipleContactos,
    showDeleteMultipleContactos,
    toggleShowDeleteMultipleContactos,
    showEditContacto,
    toggleShowEditContacto,
    handleDeleteContacto,
    setSelectedContacto,
    handleDeleteMultipleContactos,
    setSelectedMultipleContactos,
    handleDeleteContactoHttp,
    handleEditContacto,
  }

  return (
    <ContactosContext.Provider value={value}>
      {children}
    </ContactosContext.Provider>
  )
}

export const useContactosContext = () => useContext(ContactosContext)

export default ContactosProvider
